import React from "react";
import { useWindowDimensions } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import useAdminStatus from "../utility/hooks/useAdminStatus";
import { AuthProvider } from "../context/AuthContext";
import AuthenticatedRoutes from "../utility/auth/AuthenticatedRoutes";
import { NotificationProvider } from "../context/NotificationContext";
import { ChatProvider } from "../context/ChatContext";
import { LiveStreamProvider } from "../context/LiveStreamContext";
import { TooltipProvider } from "../context/WalkthroughContext";
import { WsProvider } from "../context/NativeApplicationContext";
import DesktopNavigation from "./components/DesktopNavigation";
import MobileNavigation from "./components/MobileNavigation";

export default function DrawerRoute() {
  const dimensions = useWindowDimensions();
  const deviceSize = useDeviceSize();
  const isAdmin = useAdminStatus();

  const NavigationComponent = deviceSize === DEVICE_SIZES.XL 
    ? DesktopNavigation 
    : MobileNavigation;

  return (
    <TooltipProvider>
      <AuthProvider>
        <WsProvider>
          <LiveStreamProvider>
            <NotificationProvider>
              <ChatProvider>
                <AuthenticatedRoutes>
                  <NavigationComponent 
                    dimensions={dimensions} 
                    isAdmin={isAdmin} 
                  />
                </AuthenticatedRoutes>
              </ChatProvider>
            </NotificationProvider>
          </LiveStreamProvider>
        </WsProvider>
      </AuthProvider>
    </TooltipProvider>
  );
}
